// musicmanager.ts
export type Subscriber = {
  id: string
  priority: number // 数值越大优先级越高
  play: () => Promise<void>
  pause: () => void
  onStopped: (callback: () => void) => void
}

class AudioManager {
  private subscribers: Subscriber[] = []
  private currentSubscriber: Subscriber | null = null
  private themeSubscriber: Subscriber | null = null

  subscribe(subscriber: Subscriber) {
    this.subscribers.push(subscriber)
    if (subscriber.priority === 0) {
      this.themeSubscriber = subscriber
    }
  }

  unsubscribe(subscriberId: string) {
    this.subscribers = this.subscribers.filter((s) => s.id !== subscriberId)
  }

  async play(subscriberId: string) {
    const target = this.subscribers.find((s) => s.id === subscriberId)
    if (!target) return

    // 暂停当前播放
    if (this.currentSubscriber && this.currentSubscriber !== target) {
      this.currentSubscriber.pause()
    }

    try {
      await target.play()
      this.currentSubscriber = target

      // 注册停止回调
      target.onStopped(() => this.tryPlayTheme())
    } catch (error) {
      console.error('Play failed:', error)
    }
  }

  private tryPlayTheme() {
    if (!this.currentSubscriber && this.themeSubscriber) {
      this.play(this.themeSubscriber.id)
    }
  }

  pauseAll(exceptionId: string | null = null) {
    this.subscribers.forEach((s) => {
      if (s.id !== exceptionId) {
        s.pause()
      }
    })
    this.currentSubscriber = null
  }
}

export const audioManager = new AudioManager()

// 通用ID生成工具
let instanceCounter = 0

export const generateAudioId = (prefix: string) => {
  const counter = instanceCounter++ % 1000 // 防止溢出
  return `${prefix}_${performance.now().toFixed(0)}_${Math.random()
    .toString(36)
    .slice(2, 7)}_${counter.toString(36).padStart(3, '0')}`
}
